@if (_text) {
  <div class="definition-container">
    <div><strong>Definition:</strong></div>
    <div>&emsp;{{ _text }}</div>
  </div>
}
